
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/usr/src/app/ui/features/discussion-topic/jst/-deleted-entry';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  
  return "collapsable";
  }

function program3(depth0,data) {
  
  
  return "data-event=\"toggleCollapsed\"";
  }

  buffer += "<header class=\"entry-header discussion-section admin-link-hover-area ";
  if (helper = helpers.read_state) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.read_state); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " clearfix ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.collapsable), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.collapsable), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n  <div class=\"discussion-header-content right-of-avatar\">\n    <div class=\"discussion-header-right\">\n      <div class=\"headerBadges show-if-collapsed\"></div>\n    </div>\n    <div class=\"discussion-title\">";
  stack1 = (helper = helpers.__i18nliner_escape || (depth0 && depth0.__i18nliner_escape),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.editor_href), options) : helperMissing.call(depth0, "__i18nliner_escape", (depth0 && depth0.editor_href), options));
  stack1 = (helper = helpers.__i18nliner_concat || (depth0 && depth0.__i18nliner_concat),options={hash:{},data:data},helper ? helper.call(depth0, "<a href=\"", stack1, "\" tabindex=\"0\">$1</a>", options) : helperMissing.call(depth0, "__i18nliner_concat", "<a href=\"", stack1, "\" tabindex=\"0\">$1</a>", options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': (stack1),
    'editor_name': ((depth0 && depth0.editor_name)),
    'edited_at': ((depth0 && depth0.edited_at)),
    'i18n_scope': ("discussions.deleted_entry")
  },data:data},helper ? helper.call(depth0, "discussions.deleted_entry.deleted", "Deleted by *%{editor_name}* on %{edited_at}", options) : helperMissing.call(depth0, "t", "discussions.deleted_entry.deleted", "Deleted by *%{editor_name}* on %{edited_at}", options)))
    + "</div>\n  </div>\n</header>\n\n";
  return buffer;
  });
    
      Handlebars.registerPartial('ui/features/discussion_topic/jst/_deleted_entry.handlebars', templates['/usr/src/app/ui/features/discussion-topic/jst/-deleted-entry']);
    ;
    ;
    export default templates[name];
  